import connect from '../api/connect'
import Shipment from '../../types/api/shipment'
import Task from '../../types/api/task'
import { StrapiCreate } from '../../types/strapi/strapi'

export default function extractCreateDrawingBlankTaskArg(
    shipment: Shipment,
    description?: string
): StrapiCreate<Task> {
    return {
        data: {
            type: 'Отрисовка бланка',
            performer: connect(shipment.designer),
            originType: 'shipment',
            originId: shipment.documentId,
            shipment: connect(shipment),
            description,
            details: {},
            taskStatus: 'Новая',
        },
    }
}
